import { render, staticRenderFns } from "./SizeOption.vue?vue&type=template&id=2238771a&"
import script from "./SizeOption.vue?vue&type=script&lang=js&"
export * from "./SizeOption.vue?vue&type=script&lang=js&"
import style0 from "./SizeOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports